import { Subscribable } from 'knockout';
import DiscussionTermsManager from 'managers/discussion/terms';
import { IWCCStorageManager } from 'managers/iStorage';
import { ShellHelpers } from 'shells/helpers/helpers';
import { ShellRoutesGroupConfig } from './routesComposition';

export default class ShellTermsRoutes implements ShellRoutesGroupConfig {
    exclusive = true;

    routes: Array<DurandalRouteConfiguration>

    ready: Subscribable<boolean>
    enable: Subscribable<boolean>

    constructor(storage: IWCCStorageManager) {
        const { discussionId } = settings;

        if (discussionId != undefined) {
            const termsManager = <DiscussionTermsManager>storage.getInstance(DiscussionTermsManager, { discussionId });
            const hasToAgreeToTerms = ko.pureComputed(() => settings.showAgreePage && !termsManager.agreedToTermsAndConditions() && ShellHelpers.isLoggedIn());

            this.ready = termsManager.busy.not();
            this.enable = hasToAgreeToTerms;
        } else {
            this.ready = ko.pureComputed(() => false);
            this.enable = ko.pureComputed(() => false);
        }

        this.routes = [
            { route: '', title: 'Agree To Terms', moduleId: () => import('pages/discussions/terms/page') },
            { route: 'agreetoterms', title: 'Agree To Terms', moduleId: () => import('pages/discussions/terms/page') },
        ]        
    }
}